export default {
  getHead: () => {
    return [{name: '분야명'}, {name: '현장명'}, {name: '구분'}, {name: '종류'}, {name: '현장주소'}, {name: '착공일'}, {name: '준공일'}, {name: '사업금액'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).inputA_1
        case 1: return func.getContent(value).inputA_2
        case 2: return func.getContent(value).inputA_4
        case 3: return {type: 'member', memberId: func.getContent(value).inputA_5}
        case 4: return {type: 'member', memberId: func.getContent(value).inputA_6}
        case 5: return func.getCreatedDate(value.created_at)
        case 6: return func.getContent(value).inputA_3
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { inputB_6: nav.value.created_at}
  },
  getSearchKeyword: (nav) => {
    return []
  },
}
